var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('Tree',{attrs:{"data":_vm.baseData,"show-checkbox":""}}),_c('Button',{staticClass:"button",attrs:{"type":"primary"},on:{"click":_vm.submit}},[_vm._v("提交")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }